<p-dialog
  header="Add Group"
  [position]="'center'"
  appendTo="body"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [closable]="!saving()"
  [closeOnEscape]="!saving()"
  [(visible)]="visible"
  (onHide)="closeModal()"
  styleClass="add-group-dialog"
  [style]="{
    width: '550px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col">
    <!-- Loading State -->
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-4">
        <p-progressSpinner
          styleClass="groups-spinner"
          strokeWidth="4"
          animationDuration=".8s" />
        <span class="ms-3 text-color">Loading groups...</span>
      </div>
    } @else {
      <!-- Available Groups List -->
      <div class="group-list overflow-y-auto rounded-3 p-1">
        @for (group of availableGroups; track group.name) {
          <div class="group-item border-bottom mb-2">
            <div>
              <div
                class="group-row d-flex align-items-center justify-content-between py-3 pointer"
                (click)="toggleGroupExpand(group)">
                <div class="group-main d-flex align-items-center gap-3">
                  <div class="group-icon-wrap">
                    <i class="pi pi-users text-color"></i>
                  </div>

                  <div class="group-text">
                    <div
                      #modalGroupNameEl
                      class="fw-semibold title-color group-name text-truncate w-100"
                      [pTooltip]="group.name"
                      tooltipPosition="top"
                      [tooltipDisabled]="
                        modalGroupNameEl.scrollWidth <=
                        modalGroupNameEl.clientWidth
                      ">
                      {{ group.name }}
                    </div>
                    <small class="text-color">group</small>
                  </div>
                </div>
                <div class="group-actions d-flex align-items-center gap-3">
                  <span class="user-badge rounded-4 small fw-medium"
                    >{{ group.userCount }} User</span
                  >
                  <p-checkbox
                    [(ngModel)]="group.selected"
                    [binary]="true"
                    [inputId]="'group-' + group.name"
                    (onChange)="onGroupSelectionChange(group)"
                    (click)="$event.stopPropagation()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <!-- Expanded Users List -->
            @if (group.expanded) {
              <div
                class="group-users-list ms-0 py-1 px-2 gap-3 d-flex flex-column overflow-hidden">
                @for (user of group.users; track user.email) {
                  <div
                    class="group-user-row d-flex align-items-center justify-content-between py-2">
                    <div
                      class="group-user-main d-flex align-items-center gap-2">
                      <i class="pi pi-user title-color"></i>
                      <span
                        #modalGroupUserEl
                        class="group-user-name w-100 title-color text-truncate"
                        [pTooltip]="user.name"
                        tooltipPosition="top"
                        [tooltipDisabled]="
                          modalGroupUserEl.scrollWidth <=
                          modalGroupUserEl.clientWidth
                        ">
                        {{ user.email }}
                      </span>
                    </div>
                    <p-checkbox
                      [(ngModel)]="user.selected"
                      [binary]="true"
                      [inputId]="'user-' + user.email"
                      (onChange)="onUserSelectionChange(group)">
                    </p-checkbox>
                  </div>
                }
                <!-- Add Person Toggle -->
                @if (!group.showAddPerson) {
                  <div
                    class="d-flex align-items-center gap-2 pointer add-person-link d-flex align-items-center justify-content-end gap-3 py-2 px-0 pointer"
                    (click)="toggleAddPerson(group)">
                    <i class="pi pi-user-plus title-color"></i>
                    <span class="text-color">Add Person</span>
                  </div>
                } @else {
                  <div
                    class="d-flex align-items-center gap-2 py-2 overflow-visible position-relative">
                    <p-autocomplete
                      class="flex-grow-1"
                      [(ngModel)]="group.newPersonEmail"
                      [suggestions]="suggestions"
                      field="email"
                      (completeMethod)="searchUsers($event, group)"
                      (onSelect)="onUserSelect($event, group)"
                      placeholder="Enter email"
                      [forceSelection]="false"
                      [dropdown]="false"
                      [disabled]="saving()"
                      [appendTo]="'body'">
                    </p-autocomplete>

                    <p-button
                      label="Add"
                      size="small"
                      [disabled]="saving()"
                      [loading]="saving()"
                      (click)="addPersonToGroup(group)">
                    </p-button>
                  </div>
                }
              </div>
            }
          </div>
        } @empty {
          <div class="text-muted text-center py-3">No groups available</div>
        }
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex flex-column pt-3 w-100">
      @if (validationMessage) {
        <small class="text-danger mb-2" role="alert">
          {{ validationMessage }}
        </small>
      }
      <div class="d-flex justify-content-between align-items-center w-100">
        <a class="create-new-link rounded-3 fs-6" (click)="onCreateNewGroup()"
          >Create New</a
        >
        <div class="d-flex gap-2">
          <p-button
            label="Cancel"
            [disabled]="saving()"
            (click)="closeModal()"
            styleClass="add-group__btn add-group__cancel-btn"
            variant="outlined"
            severity="secondary" />
          <p-button
            label="Add"
            styleClass="add-group__btn"
            [disabled]="saving() || loading"
            (click)="addSelectedGroups()" />
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
